interface Options {
  mode?: 'mysearch' | 'management' | null,
  saveImpl?: () => void
}

export const useCsSave = (options?: Options) => {
  const mode: 'mysearch' | 'management' | null = options?.mode
    ? options.mode
    : null

  const isSaving: Ref<boolean> = ref(false)
  let version = null
  const defaultSaveImpl = async () => {
    try {
      isSaving.value = true
      let cs: CustomSearchDefinition = clone(undo.undoable.value)
      if (isEmpty(cs.image)) delete cs.image
      if (isEmptyLangDelta(cs.help)) delete cs.help
      setVersion(cs, version)
      let c = await updateCustomSearch(cs)
      version = getVersion(c)
    } catch (e) {
      snackbarError({ ja: '保存に失敗しました' })
      throw e
    } finally {
      isSaving.value = false
    }
  }
  const _saveImpl: () => void = options?.saveImpl
    ? options.saveImpl
    : defaultSaveImpl

  const undo = useUndo({
    saveImpl: _saveImpl,
  })

  const { snackbarError } = useSnackbar()
  const { updateCustomSearch } = useCustomSearch()
  const { initCsForEdit } = useCsEditor()

  undo.undoable.value = null
  const db: Ref<Database> = ref(null)

  const editstate = computed((): CsEditState => {
    return {
      canUndo: undo.canUndo.value,
      canRedo: undo.canRedo.value,
      canSave: undo.canSave.value,
      isSaving: isSaving.value,
      cs: undo.undoable.value,
      db: db.value,
      mode: mode,
      undo: undo.undo,
      redo: undo.redo,
      save: undo.save,
      snapshot: undo.snapshot,
    }
  })

  const startEdit = (c: CustomSearchDefinition, d?: Database) => {
    if (d) db.value = d
    initCsForEdit(c)
    version = getVersion(c)
    removeVersion(c)
    undo.undoable.value = c
    nextTick(() => {
      undo.resetHistory()
    })
  }

  return {
    undo,
    editstate,
    startEdit,
  }

}

